import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import OrderExpiredReportList, { DispatchProps, OwnProps, StateProps } from './OrderExpiredReportList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getOrderExpiredReports, getOrderExpiredReportsCsv } from 'src/store/actions/orderExpiredReport-actions';
import { selectNameStudents } from 'src/store/selectors/students-selectors';
import { selectNameVendors } from 'src/store/selectors/vendors-selectors';
import { selectNameDistricts } from 'src/store/selectors/districts-selectors';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { selectNameSerTypesDropDown } from '../../../../../store/selectors/service-types-selectors';
import { getServiceTypes } from '../../../../../store/actions/service-type-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.orderExpiredReports.data,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        serviceTypes: selectNameSerTypesDropDown(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getOrderExpiredReports(params)),
        getDataCsv: (params: QueryParams) => dispatch(getOrderExpiredReportsCsv(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const OrderExpiredReportListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(OrderExpiredReportList);

export default OrderExpiredReportListScreen;
